import api from '../../plugins/api';

const accessVerifyCode = ({ phone, code, dealId }) => {
  return api.get('/api/resource/accessVerifyCode', { phone, code, dealId });
};

export default accessVerifyCode;
